/*
 * consent.js — Cookie-/Consent-Steuerung über die Shopify Customer-Privacy-API.
 * docs/10 E3 (Pflicht). Verwaltet NUR den Consent-Status:
 *   - lädt Shopify.loadFeatures(['consent-tracking-api'])
 *   - zeigt das Banner (#hm-consent) nur, wenn noch keine Wahl getroffen wurde
 *   - setzt setTrackingConsent({analytics,marketing,preferences,sale_of_data}) je Aktion
 *   - granulares Sub-Panel (#hm-consent-settings) via window.Homedia.overlay (Dialog)
 *   - Re-Open via [data-consent-open] (Footer)
 *   - dispatcht 'consent:updated' auf document (für späteres GA4/Clarity/Pixel-WP)
 *
 * GA4/Clarity/Pixel werden hier NICHT geladen — nur Status + Event.
 *
 * sale_of_data FOLGT marketing (nicht: hart false). Grund — live verifiziert:
 * Shopify lädt ein Web Pixel nur, wenn für JEDEN von ihm deklarierten Zweck eine Einwilligung
 * vorliegt („Shopify's pixel manager will only load your pixel if there is visitor permission
 * for all of the settings that your pixel declares as required",
 * https://shopify.dev/docs/api/web-pixels-api/pixel-privacy). Das Meta-App-Pixel deklariert
 * privacyPurposes: ["ANALYTICS","MARKETING","SALE_OF_DATA"] (nachgelesen in webPixelsConfigList
 * im Storefront-HTML). Solange wir sale_of_data hart auf false setzten, konnte der Meta-BROWSER-
 * Pixel für Besucher aus Consent-Regionen NIE laden — auch nicht nach „Alle akzeptieren":
 * fbq blieb undefined, fbevents.js wurde nie geladen, Meta bekam nur Server-Events (CAPI).
 * A/B live gegengeprüft (beide Richtungen): sale_of_data=no → kein fbq; =yes → fbq + fbevents.js.
 * Google ist davon unberührt (privacyPurposes: [] → lädt immer, Consent Mode v2).
 *
 * Semantik: Wer Marketing zustimmt, willigt genau in die Weitergabe an Werbeplattformen ein —
 * das ist der Zweck, den sale_of_data abbildet. Ohne Marketing-Zustimmung bleibt es false.
 * Banner ist NICHT modal (overlay.js trapt ihn nicht) — er blockiert das Stöbern nicht.
 * Das Settings-Sub-Panel IST ein Dialog (Fokus-Trap via overlay.js).
 */
(function () {
  'use strict';

  var root = document.getElementById('hm-consent'); // das <aside> ist der sichtbare Banner-Container
  if (!root) return;

  var settingsPanel = document.getElementById('hm-consent-settings');
  var form = settingsPanel ? settingsPanel.querySelector('[data-consent-form]') : null;

  var CATEGORIES = ['analytics', 'marketing', 'preferences'];

  function overlay() {
    return window.Homedia && window.Homedia.overlay;
  }

  function privacy() {
    return window.Shopify && window.Shopify.customerPrivacy;
  }

  // Solange der Banner sichtbar ist, markieren wir das am <html>. Sections können darauf reagieren
  // (aktuell: die permanente Sticky-Kaufleiste der Produktseite fährt ein, weil die Banner-Karte
  // sie ≤749px überlagert — siehe sections/main-product.liquid).
  // Bewusst NICHT `data-consent-open`: das ist der Re-Open-Trigger im Footer und wird unten per
  // e.target.closest('[data-consent-open]') gesucht. Am <html> (Vorfahr von allem) würde JEDER
  // Klick auf der Seite matchen und das Einstellungs-Panel öffnen.
  var HTML_FLAG = 'data-consent-visible';

  function showBanner() {
    document.documentElement.setAttribute(HTML_FLAG, '');
    var o = overlay();
    if (o) {
      // Blockierender, modaler Consent-Dialog: Scroll-Lock + Fokus-Trap + Backdrop kommen aus
      // overlay.js. [data-overlay-mandatory] verhindert das Schließen per Escape, und weil der
      // Backdrop KEIN data-overlay-close trägt, ist auch Klick-außerhalb kein Ausweg → der Nutzer
      // MUSS aktiv akzeptieren oder ablehnen. open() setzt data-state=open + fokussiert den Titel.
      if (!o.isOpen(root)) o.open(root, { labelledby: 'hm-consent-title' });
      return;
    }
    // Fallback (overlay.js nicht verfügbar): wenigstens sichtbar machen (nicht modal).
    if (root.hasAttribute('hidden')) {
      root.hidden = false;
      requestAnimationFrame(function () { root.setAttribute('data-state', 'open'); });
    }
  }

  function hideBanner() {
    // Flag immer räumen (idempotent), auch wenn der Banner nie sichtbar war.
    document.documentElement.removeAttribute(HTML_FLAG);
    var o = overlay();
    if (o && o.isOpen(root)) {
      o.close(root);
      return;
    }
    if (!root.hasAttribute('hidden')) {
      root.setAttribute('data-state', 'closed');
      root.hidden = true;
    }
  }

  /* ----- Status-Helper ----- */

  // True, sobald der Besucher eine Wahl getroffen hat.
  function consentCollected() {
    var p = privacy();
    if (!p) return false;
    // 1) Hat der Besucher bereits aktiv entschieden? Verlässliche, Reload-feste Quelle.
    //    getTrackingConsent() ist nur VOR jeder Wahl 'no_interaction'; danach 'yes'/'no'/'partial'.
    //    WICHTIG: shouldShowBanner() bleibt bei entferntem Shopify-Banner in Pflichtregionen
    //    dauerhaft true (auch NACH Zustimmung) — daher NICHT allein darauf verlassen, sonst
    //    erscheint das Banner bei jedem Seitenaufruf erneut.
    try {
      var status = (typeof p.getTrackingConsent === 'function') ? p.getTrackingConsent() : null;
      if (status && status !== 'no_interaction') return true;
    } catch (e) {}
    // 2) Noch keine Wahl → Shopifys Region-Hinweis nutzen (zeigt nur in Pflichtregionen).
    try {
      if (typeof p.shouldShowBanner === 'function') return !p.shouldShowBanner();
    } catch (e2) {}
    return false;
  }

  // Aktuellen Status in die Toggles spiegeln (für Re-Open / „Einstellungen“).
  function syncToggles() {
    var p = privacy();
    if (!form || !p) return;
    var current = {};
    try {
      if (typeof p.currentVisitorConsent === 'function') current = p.currentVisitorConsent() || {};
    } catch (e) {}
    CATEGORIES.forEach(function (cat) {
      var input = form.querySelector('[data-consent-cat="' + cat + '"]');
      if (!input) return;
      // API liefert 'yes'/'no'/'' — nur explizites 'yes' setzt den Toggle (kein Pre-Checked).
      input.checked = current[cat] === 'yes' || current[cat] === true;
    });
  }

  /* ----- Consent setzen ----- */

  function setConsent(consent, opts) {
    var p = privacy();
    opts = opts || {};
    var payload = {
      analytics: !!consent.analytics,
      marketing: !!consent.marketing,
      preferences: !!consent.preferences,
      // sale_of_data folgt marketing (s. Datei-Kopf) — sonst blockiert Shopify das Meta-Pixel,
      // das SALE_OF_DATA als Pflicht-Zweck deklariert. Explizite Übergabe schlägt die Kopplung.
      sale_of_data: consent.sale_of_data === undefined
        ? !!consent.marketing
        : consent.sale_of_data === true
    };

    // Einmal-Guard: finish() darf höchstens einmal laufen (Callback ODER Watchdog).
    var finished = false;
    function finish() {
      if (finished) return;
      finished = true;
      // Erst das (obenauf liegende) Settings-Panel schließen, dann den Banner — so wandert der
      // Fokus sauber zurück und overlay.js' Scroll-Lock-Zähler löst sich vollständig.
      if (opts.closePanel && settingsPanel && overlay() && overlay().isOpen(settingsPanel)) {
        overlay().close(settingsPanel);
      }
      hideBanner();
      document.dispatchEvent(new CustomEvent('consent:updated', {
        bubbles: true,
        detail: payload
      }));
    }

    if (p && typeof p.setTrackingConsent === 'function') {
      try {
        p.setTrackingConsent(payload, function (result) {
          // Fail-open: der Klick darf nie verschluckt werden — Banner schließen und Event feuern.
          // Bei echtem Speicherfehler zeigt shouldShowBanner das Banner beim nächsten Aufruf erneut.
          if (result && (result.error || (result.errors && result.errors.length))) {
            try { console.warn('[consent] setTrackingConsent meldete Fehler:', result); } catch (e2) {}
          }
          finish();
        });
        // WATCHDOG (Pflicht wegen des BLOCKIERENDEN Modals): Ruft die API ihren Callback nie auf
        // (SDK-Fehler verschluckt, Netz-Stall, künftige Regression), bliebe der Dialog wegen
        // Scroll-Lock/Fokus-Trap/„Escape schließt nicht" SONST DAUERHAFT gesperrt = Total-Lockout.
        // Nach 2,5 s trotzdem freigeben — die Consent-Schreiboperation läuft serverseitig unabhängig
        // vom Callback weiter, wir schließen also nur die UI (idempotent per finished-Guard).
        setTimeout(finish, 2500);
        return;
      } catch (e) {
        // Fallback: trotzdem schließen + Event feuern.
      }
    }
    finish();
  }

  // sale_of_data wird bewusst NICHT übergeben → setConsent koppelt es an marketing (s. Datei-Kopf).
  function acceptAll() {
    setConsent({ analytics: true, marketing: true, preferences: true });
  }

  function rejectAll() {
    setConsent({ analytics: false, marketing: false, preferences: false });
  }

  function saveSelection() {
    var consent = { analytics: false, marketing: false, preferences: false };
    if (form) {
      CATEGORIES.forEach(function (cat) {
        var input = form.querySelector('[data-consent-cat="' + cat + '"]');
        consent[cat] = !!(input && input.checked);
      });
    }
    setConsent(consent, { closePanel: true });
  }

  /* ----- Sub-Panel öffnen ----- */

  function openSettings(trigger) {
    if (!settingsPanel || !overlay()) return;
    syncToggles();
    overlay().open(settingsPanel, {
      trigger: trigger || null,
      labelledby: 'hm-consent-settings-title'
    });
  }

  /* ----- Wiring ----- */

  function wire() {
    // Banner-Aktionen
    var accept = root.querySelector('[data-consent-accept]');
    var reject = root.querySelector('[data-consent-reject]');
    var settings = root.querySelector('[data-consent-settings]');
    if (accept) accept.addEventListener('click', acceptAll);
    if (reject) reject.addEventListener('click', rejectAll);
    if (settings) settings.addEventListener('click', function (e) { openSettings(e.currentTarget); });

    // Sub-Panel speichern
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        saveSelection();
      });
    }

    // Re-Open aus dem Footer (oder überall): [data-consent-open]
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-consent-open]');
      if (!opener) return;
      e.preventDefault();
      openSettings(opener);
    });
  }

  /* ----- Privacy-API laden & Sichtbarkeit ----- */

  function evaluate() {
    syncToggles();
    if (!consentCollected()) {
      showBanner();
    } else {
      hideBanner();
    }
  }

  function onFeatures() {
    evaluate();
    // Shopify feuert dieses Event nach einer Entscheidung (z. B. aus anderem Tab/Quelle).
    document.addEventListener('visitorConsentCollected', function () {
      hideBanner();
      syncToggles();
    });
  }

  function init() {
    wire();
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        function (error) {
          if (error) {
            // API nicht verfügbar → Banner aus Vorsicht zeigen, damit eine Wahl möglich ist.
            showBanner();
            return;
          }
          onFeatures();
        }
      );
    } else if (privacy()) {
      onFeatures();
    } else {
      // Privacy-API (noch) nicht da → Banner zeigen; Wiring bleibt aktiv.
      showBanner();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
